import styles from '../../css/MainSearch.module.css';
import { useState } from 'react';
import MultiRangeSlider from '../../component/MultiRangeSlider2';

export default function MainSearchArea({  
  sectorData,
  analysisData,
  searchClusterByMul
}) {
  const [numMin, setNumMin] = useState(0);
  const [numMax, setNumMax] = useState(1640);
  const [omegaMin, setOmegaMin] = useState(0);
  const [omegaMax, setOmegaMax] = useState(50);
  const [payMin, setPayMin] = useState(0);
  const [payMax, setPayMax] = useState(84000);

  const [numType, setNumType] = useState(false);
  const [omegaType, setOmegaType] = useState(false);
  const [payType, setPayType] = useState(false);
  const [numCond, setNumCond] = useState(false);
  const [omegaCond, setOmegaCond] = useState(false);
  const [payCond, setPayCond] = useState(false);

  const [rangeHigh, setRangeHigh] = useState(false);
  const [rangeLow, setRangeLow] = useState(false);
  const [range10, setRange10] = useState(false);
  const [range20, setRange20] = useState(false);
  const [range30, setRange30] = useState(false);

  const [areaList, setAreaList] = useState([]);
  const [analList, setAnalList] = useState([]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!numType && !omegaType && !payType) {
      alert("기준 조건을 선택해 주십시요.");
      return false;
    }

    // api 호출 이벤트 처리 
    let data = {}

    // 기준
    let searchList = [];

    if (numType) {
      let cond = 'AND';
      if (numCond) {
        cond = 'OR';
      }
      searchList.push({'type':'num','cond':cond,'min':numMin,'max':numMax})
    }

    if (omegaType) {
      let cond = 'AND';
      if (omegaCond) {
        cond = 'OR';
      }
      searchList.push({'type':'omega','cond':cond,'min':omegaMin,'max':omegaMax})
    }

    if (payType) {
      let cond = 'AND';
      if (payCond) {
        cond = 'OR';
      }
      searchList.push({'type':'pay','cond':cond,'min':payMin,'max':payMax})
    }
    
    data['search_type'] = searchList;

    // 범위
    if (rangeHigh) {
      data['range_type'] = 'high';
    } else if (rangeLow) {
        data['range_type'] = 'low';
    } else {
      data['range_type'] = '';
    }

    if (range10) {
      data['range_num'] = '10';
    } else if (range20) {
      data['range_num'] = '20';
    } else if (range30) {
      data['range_num'] = '30';
    } else {
      data['range_num'] = '';
    }
    
    // 구역
    data['area'] = areaList;

    // 상권분석   
    data['search_anal'] = analList;

    searchClusterByMul(data);
  };
  
  const handleRangeNum = (min, max) => {
    setNumMin(min);
    setNumMax(max);    
  };

  const handleRangeOmega = (min, max) => {
    setOmegaMin(min);
    setOmegaMax(max);    
  };

  const handleRangePay = (min, max) => {
    setPayMin(min);
    setPayMax(max);    
  };

  const mulreset = (e) => {
    // 기준 초기화
    setNumType(false);
    setOmegaType(false);
    setPayType(false);
    setNumCond(false);
    setOmegaCond(false);
    setPayCond(false);

    setNumMin(0);
    setNumMax(1640);
    setOmegaMin(0);
    setOmegaMax(50);
    setPayMin(0);
    setPayMax(84000);  
    
    setRangeHigh(false);
    setRangeLow(false);
    setRange10(false);
    setRange20(false);
    setRange30(false);
  
    let checkboxes = document.getElementsByName('gu');

    for (let checkbox of checkboxes) {
      checkbox.checked = false;
    }
    setAreaList([]);

    checkboxes = document.getElementsByName('anal');
    for (let checkbox of checkboxes) {
      checkbox.checked = false;
    }
    setAnalList([]);
  };

  const handleSelect = (e, type) => {
    if (e.target.checked) {
      if (type == 'num') {
        setNumType(true);
      } else if (type == 'omega') {
        setOmegaType(true);
      } else if (type == 'pay') {
        setPayType(true);
      }
    } else {
      if (type == 'num') {
        setNumType(false);
      } else if (type == 'omega') {
        setOmegaType(false);
      } else if (type == 'pay') {
        setPayType(false);
      }
    }
  };

  const handleSelectCond = (e, type) => {
    if (e.target.checked) {
      if (type == 'num') {
        setNumCond(true);
      } else if (type == 'omega') {
        setOmegaCond(true);
      } else if (type == 'pay') {
        setPayCond(true);
      }
    } else {
      if (type == 'num') {
        setNumCond(false);
      } else if (type == 'omega') {
        setOmegaCond(false);
      } else if (type == 'pay') {
        setPayCond(false);
      }
    }
  }

  const handleRangeSelect = (e, type) => {
    if (e.target.checked) {
      if (type == 'high') {
        setRangeHigh(true);
        setRangeLow(false);
      } else {
        setRangeHigh(false);
        setRangeLow(true);
      }
    } else {
      setRangeHigh(false);
      setRangeLow(false);
    }
  }

  const handleRangeNumSelect = (e, type) => {
    if (e.target.checked) {
      if (type == '10') {
        setRange10(true);
        setRange20(false);
        setRange30(false);
      } else if (type == '20') {
        setRange10(false);
        setRange20(true);
        setRange30(false);
      } else {
        setRange10(false);
        setRange20(false);
        setRange30(true);
      }
    } else {
      setRange10(false);
      setRange20(false);
      setRange30(false);
    }
  }

  const handleAreaSelect = (e) => {
    if (e.target.checked) {
      // 추가
      setAreaList([...areaList, e.target.value]);
    } else {
      // 삭제
      const updatedItems = areaList.filter(item => item !== e.target.value);
      setAreaList(updatedItems);
    }
  }

  const handleAnalSelect = (e) => {
    if (e.target.checked) {
      // 추가
      setAnalList([...analList, e.target.value]);
    } else {
      // 삭제
      const updatedItems = analList.filter(item => item !== e.target.value);
      setAnalList(updatedItems);
    }
  }

  return (
    <div className={styles.mainForm}>
      <div className={styles.ex} >
        <div className={styles.rangeBox}>
          <h1>기준</h1>
          <ul>
            <li className={styles.flex}>
              <div style={{width: '45%', display: 'flex'}}>
                <input type='checkbox'
                  name='cluster'
                  id='mul-num'
                  onChange={(e) => handleSelect(e, 'num')}
                  checked={numType}
                />
                <label style={{display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '12px'}} htmlFor='mul-num'>상점수</label>
                {/* <input type='checkbox' 
                  id='mul-num-emul' 
                  onChange={(e) => handleSelectCond(e, 'num')}
                  checked={numCond}
                />
                <label className={styles.baseBtn} style={{width: '35px', display: 'flex', alignItems: 'center'}} htmlFor='mul-num-emul'>OR</label> */}
              </div>

              <div style={{width: '63.5%', display: 'flex', justifyContent: 'flex-end'}}>
                <MultiRangeSlider
                  min={0}
                  max={1640}
                  rangeMin={numMin}
                  rangeMax={numMax}
                  setRangeMin={setNumMin}
                  setRangeMax={setNumMax}
                  onChange={({ min, max }) => handleRangeNum(min, max)}
                />
              </div>
            </li>
            <li className={styles.flex}>
              <div style={{width: '45%', display: 'flex'}}>
                <input type='checkbox'
                  name='cluster'
                  id='mul-omega'
                  onChange={(e) => handleSelect(e, 'omega')}
                  checked={omegaType}
                />
                <label style={{display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '12px'}} htmlFor='mul-omega'>회복탄력성</label>
                {/* <input type='checkbox' 
                  id='mul-omega-emul' 
                  onChange={(e) => handleSelectCond(e, 'omega')}
                  checked={omegaCond}
                />
                <label className={styles.baseBtn} style={{width: '35px', display: 'flex', alignItems: 'center'}} htmlFor='mul-omega-emul'>OR</label> */}
              </div>

              <div style={{width: '63.5%', display: 'flex', justifyContent: 'flex-end'}}>
                <MultiRangeSlider
                  min={0}
                  max={50}
                  rangeMin={omegaMin}
                  rangeMax={omegaMax}
                  setRangeMin={setOmegaMin}
                  setRangeMax={setOmegaMax}
                  onChange={({ min, max }) => handleRangeOmega(min, max)}
                />
              </div>
            </li>
            <li className={styles.flex}>
              <div style={{width: '45%', display: 'flex'}}>
                <input type='checkbox'
                  name='cluster'
                  id='mul-pay'
                  onChange={(e) => handleSelect(e, 'pay')}
                  checked={payType}
                />
                <label style={{display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '12px'}} htmlFor='mul-pay'>매출액(백만원)</label>
                {/* <input type='checkbox' 
                  id='mul-pay-emul' 
                  onChange={(e) => handleSelectCond(e, 'pay')}
                  checked={payCond}
                />
                <label className={styles.baseBtn} style={{width: '35px', display: 'flex', alignItems: 'center'}} htmlFor='mul-pay-emul'>OR</label> */}
              </div>

              <div style={{width: '63.5%', display: 'flex', justifyContent: 'flex-end'}}>
                <MultiRangeSlider
                  min={0}
                  max={84000}
                  rangeMin={payMin}
                  rangeMax={payMax}
                  setRangeMin={setPayMin}
                  setRangeMax={setPayMax}
                  onChange={({ min, max }) => handleRangePay(min, max)}
                />
              </div>
            </li>
          </ul>

          <h1>범위</h1>
          <ul className={styles.flex}>
            <li className={styles.gubun} style={{width: '49.5%'}}>
              <input type='checkbox'
                name='gubun'
                id='mul-high'
                onChange={(e) => handleRangeSelect(e, 'high')}
                checked={rangeHigh}
              />
              <label htmlFor='mul-high'>상위</label>
            </li>
            <li className={styles.gubun} style={{width: '49.5%'}}>
              <input type='checkbox'
                name='gubun'
                id='mul-low'
                onChange={(e) => handleRangeSelect(e, 'low')}
                checked={rangeLow}
              />
              <label htmlFor='mul-low'>하위</label>
            </li>
          </ul>
          <ul className={styles.flex}>
            <li className={styles.item} style={{width: '32.7%'}}>
              <input type='checkbox'
                name='cluster'
                id='mul-10'
                onChange={(e) => handleRangeNumSelect(e, '10')}
                checked={range10}
              />
              <label htmlFor='mul-10'>10</label>
            </li>
            <li className={styles.item} style={{width: '32.7%'}}>
              <input type='checkbox'
                name='cluster'
                id='mul-20'
                onChange={(e) => handleRangeNumSelect(e, '20')}
                checked={range20}
              />
              <label htmlFor='mul-20'>20</label>
            </li>
            <li className={styles.item} style={{width: '32.7%'}}>
              <input type='checkbox'
                name='cluster'
                id='mul-30'
                onChange={(e) => handleRangeNumSelect(e, '30')}
                checked={range30}
              />
              <label htmlFor='mul-30'>30</label>
            </li>
          </ul>

          <h1>구역</h1>
          <ul className={styles.toggleSelect} style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
            {
              sectorData.map((menu, code) => (
                <li key={code} style={{width: '19.3%'}}>
                  <input type='checkbox'
                    name='gu'
                    className='checkSel'
                    value={menu.value}
                    id={'mul-'+menu.code}
                    onChange={(e) => handleAreaSelect(e)}
                  />
                  <label htmlFor={'mul-'+menu.code}
                    className='checkbox'>
                    {menu.value}
                  </label>
                </li>
              ))
            }
          </ul>

          <h1>상권분석</h1>
          <ul className={styles.category} style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
            {
              analysisData.map((menu, code) => (
                <li key={code} style={{width: '32.7%'}}>
                  <input type='checkbox'
                    id={`analysis_${menu.code}`}
                    name='anal'
                    value={menu.code}                    
                    onChange={(e) => handleAnalSelect(e)}
                  />
                  <label htmlFor={`analysis_${menu.code}`}>
                    {menu.value}
                  </label>
                </li>
              ))
            }
          </ul>
          
          <div className={styles.confirmDiv}>
            <button type='button' className={styles.confirmButton} style={{width:'35%'}} onClick={mulreset}>초기화</button>
            <button type='button' className={styles.confirmButton} style={{width:'35%'}} onClick={onSubmit}>확인</button>
          </div>
        </div>
      </div>      
    </div>
  )
}